function CustomPageTransition() {}

CustomPageTransition.prototype.leave = function (doneCallback) {
	gsap.to(".page-transition", {
		x: '0%',
		duration : 0.5,
		ease: 'power1.out',
		// Ne pas supprimer, sert pour naviguer à la page suivante après la transition
		onComplete: function () {
			doneCallback();
		}
	});
};

CustomPageTransition.prototype.enter = function (doneCallback) {
	gsap.to(".page-transition", {
		x: '-101%',
		duration : 0.5,
		ease: 'power1.out',
		// Ne pas supprimer, sert pour lancer les animations après la transition
		onComplete: function () {
			doneCallback();
		}
	});
};
